/* eslint-disable react-hooks/exhaustive-deps */
/**
 * BackButton Component
 * 
 * Handles Android hardware back button press
 * - Shows exit confirmation dialog for root screens
 * - Hides loader on back press
 * - Exits app on confirmation
 * 
 * @component
 * @param {boolean} isRoot - Whether this is a root screen (shows exit dialog)
 */
import React, { useEffect, useState } from 'react';
import { BackHandler } from 'react-native';
import { Dialog, Portal, Button, Text } from 'react-native-paper';
import { useDispatch } from 'react-redux';
import { hideLoader } from '../store/info.slice';

export default function BackButton({ isRoot }) {
  const dispatch = useDispatch();
  /**
   * Sets up hardware back button listener on mount
   */
  useEffect(() => {
    /**
     * Handles back button press
     * @returns {boolean} True to prevent default back behavior
     */
    const backAction = () => {
      dispatch(hideLoader());
      if (isRoot) {
        showDialog();
      }
      return true;
    };

    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction,
    );

    return () => backHandler.remove();
  }, []);

  const [visible, setVisible] = useState(false);
  /** Shows exit confirmation dialog */
  const showDialog = () => setVisible(true);
  /** Hides exit confirmation dialog */
  const hideDialog = () => setVisible(false);

  /**
   * Exits the application
   */
  const exitApp = () => {
    hideDialog();
    BackHandler.exitApp();
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={hideDialog}>
        <Dialog.Title>Exit App?</Dialog.Title>
        <Dialog.Content>
          <Text variant="titleMedium">
            Are you sure you want to exit?
          </Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={hideDialog}>No</Button>
          <Button onPress={exitApp}>Yes</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
}
